import axios from "axios";
import { urls } from "../../utils/AppManager";
import { getAuthHeaders } from "../../utils/headers";

export const getLeadActivityList = async (
  payload,
  query,
  fromDate,
  toDate,
  userEmail,
  advSearch,
  role,
  sortcolumn,
  sortorder
) => {
  console.log(payload, " payload");
  let url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.getLeadActivityList}?pageNumber= ${payload.currentPage}&pageSize=${
      payload.leadsRecords
    }&activityType=${payload.activityType}&activityStatus=${
      payload.activityStatus
    }&activityOwner=${payload.activityOwner}&searchQuery=${encodeURIComponent(
      query
    )}&fromDate=${fromDate}&toDate=${toDate}&userEmail=${userEmail}&advSearch=${advSearch}&role=${role}&sortcolumn=${sortcolumn}&sortorder=${sortorder}`;
  console.log("URL : ", url);
  const headers = getAuthHeaders();
  // console.log(headers, "checking headere values");
  let res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  //   if (
  //     res.data.count === 0 ||
  //     res.data.count === "0" ||
  //     res.data.leadsData.length === 0
  //   ) {
  //     url =
  //       process.env.REACT_APP_API_BASE_URL +
  //       `${urls.ManageLeadsList}?pageNumber=1&pageSize=${
  //         payload.leadsRecords
  //       }&leadStage=${payload.leadStages}&leadSource=${
  //         payload.leadSources
  //       }&leadOwner=${payload.leadOwners}&searchQuery=${encodeURIComponent(
  //         query
  //       )}&fromDate=${fromDate}&toDate=${toDate}&userEmail=${userEmail}&advSearch=${advSearch}&role=${role}&sortcolumn=${sortcolumn}&sortorder=${sortorder}`;

  //     res = await axios
  //       .get(url, { headers })
  //       .then((response) => response.data)
  //       .catch((error) => {
  //         console.log(error, "error");
  //       });
  //     return res;
  //   }
  //   else
  //   {
  // console.log(res, " activity page response")
  return res;
  //   }
};

export const getLeadActivityType = async () => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.getLeadActivityType;
  // console.log(url);
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const getLeadActivityOwner = async () => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.getLeadActivityOwner;
  // console.log(url);
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const getLeadActivityTransaction = async () => {
  const url =
    process.env.REACT_APP_API_BASE_URL + urls.getLeadActivityTransaction;
  // console.log(url);
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};
